import { render, staticRenderFns } from "./waterQualityTrends.vue?vue&type=template&id=2fe0d95e&"
import script from "./waterQualityTrends.vue?vue&type=script&lang=js&"
export * from "./waterQualityTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports